export default "__VITE_ASSET__CPIqR3IP__"